<div class="content">
    <color-widget [formControl]="activeObject.getControl(controlName)" (ngModelChange)="dirty = true">
        <ng-content></ng-content>
    </color-widget>
</div>